interface Props {
  height?: string
  width?: string
  padding?: string
  color?: string
  opacity?: number
}

const CampaignsIcon = (props: Props) => {
  const {
    height = '20',
    width = '20',
    color = 'var(--fg-white)',
    padding = 'var(--padding-xs)',
    opacity = 1,
  } = props

  return (
    <div style={{ padding: `${padding}`, opacity }}>
      <svg
        width={width}
        height={height}
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M14.1708 15.8311H5.83745V11.25C5.83745 10.7898 5.46436 10.4167 5.00412 10.4167C4.54388 10.4167 4.17079 10.7898 4.17079 11.25V15.8311C4.17079 16.7516 4.91698 17.4978 5.83745 17.4978H14.1708C15.0893 17.4951 15.8325 16.7497 15.8325 15.8311V11.25C15.8325 10.7898 15.4594 10.4167 14.9991 10.4167C14.5389 10.4167 14.1658 10.7898 14.1658 11.25L14.1708 15.8311ZM16.1474 9.80616C16.316 9.95016 16.5364 10.0187 16.7569 9.99566C16.9774 9.97266 17.1788 9.86018 17.3141 9.68449C17.6045 9.31291 17.5533 8.77901 17.1974 8.46949L10.5766 2.71949C10.2361 2.42684 9.73292 2.42684 9.39244 2.71949L2.80494 8.44616C2.44926 8.75565 2.39766 9.28924 2.68744 9.66116C2.82285 9.83664 3.02425 9.94896 3.24471 9.97196C3.46516 9.99495 3.68541 9.92659 3.85411 9.78282L9.99494 4.45949L16.1416 9.81032L16.1474 9.80616ZM10.0191 13.3228C10.9362 13.3201 11.6776 12.5749 11.6758 11.6578C11.6739 10.7408 10.9295 9.99857 10.0125 9.99949C9.0954 10.0004 8.35246 10.7441 8.35246 11.6612C8.35521 12.5797 9.1006 13.3228 10.0191 13.3228V13.3228V13.3228Z"
          fill={color}
        />
      </svg>
    </div>
  )
}
export default CampaignsIcon
